import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit'
import StoreListServices from '../../services/storeListServices'
import { CoreConfig } from '../../types/store'
import { setStoreCore } from './storeSlice'

const initialState: {
  coreList: CoreConfig[]
  storeNames: string[]
  storeNamesLoaded: boolean
} = {
  coreList: [],
  storeNames: [],
  storeNamesLoaded: false,
}

export const getCoreList = createAsyncThunk('vm-bo/storeList/getCoreList', () =>
  StoreListServices.getCoresList()
)

export const getStoreNames = createAsyncThunk(
  'vm-bo/storeList/getStoreNames',
  (core: string) => StoreListServices.getStoreNames(core)
)

const storeList = createSlice({
  name: 'vm-bo/storeList',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(
      getCoreList.fulfilled,
      (state, action: PayloadAction<CoreConfig[]>) => {
        state.coreList = action.payload
      }
    )
    builder.addCase(getStoreNames.pending, (state) => {
      state.storeNames = []
      state.storeNamesLoaded = false
    })
    builder.addCase(
      getStoreNames.fulfilled,
      (state, action: PayloadAction<string[]>) => {
        state.storeNames = action.payload
        state.storeNamesLoaded = true
      }
    )
    builder.addMatcher(setStoreCore.match, (state) => {
      state.storeNamesLoaded = false
      state.storeNames = []
    })
  },
})

export default storeList.reducer
